import { date, money, QuoteStatus } from "@lumberset/takeoff-ui";
import { Container, EmptyState, SectionHeader, Table } from "@lumberset/ui";
import { DocumentText } from "@medusajs/icons";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";
import { quotesQuery } from "../../../lib/queries";

export const Route = createFileRoute("/_app/quotes/")({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(quotesQuery),
  component: Quotes,
});

function Quotes() {
  const navigate = useNavigate();
  const { data } = useSuspenseQuery(quotesQuery);

  return (
    <>
      <Crumbs trail={[{ label: "Quotes" }]} />
      <Container className="divide-y p-0">
        <SectionHeader
          level="h1"
          title="Quotes"
          description="Every quote your yard has drafted or sent."
        />
        {data.quotes.length === 0 ? (
          <EmptyState
            icon={<DocumentText />}
            title="No quotes yet"
            description="A quote starts from a finished takeoff. Open a project and create one from there."
          />
        ) : (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Quote</Table.HeaderCell>
                <Table.HeaderCell className="max-md:hidden">Customer</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell className="max-lg:hidden">Valid until</Table.HeaderCell>
                <Table.HeaderCell className="text-right">Total</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data.quotes.map((quote) => (
                <Table.Row
                  key={quote.id}
                  data-clickable="true"
                  onClick={() => navigate({ to: "/quotes/$id", params: { id: quote.id } })}
                >
                  <Table.Cell>
                    <div className="txt-compact-small-plus text-ui-fg-base">#{quote.number}</div>
                    <div className="txt-compact-xsmall max-w-[40vw] truncate text-ui-fg-muted">
                      {quote.projectName}
                    </div>
                  </Table.Cell>
                  <Table.Cell className="max-md:hidden">{quote.customerName ?? "-"}</Table.Cell>
                  <Table.Cell>
                    <QuoteStatus status={quote.status} />
                  </Table.Cell>
                  <Table.Cell className="max-lg:hidden">{date(quote.validUntil)}</Table.Cell>
                  <Table.Cell className="tabular whitespace-nowrap text-right text-ui-fg-base">
                    {money(quote.totalCents, quote.currency)}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </Container>
    </>
  );
}
